import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';

let nextCheckboxId = 0;

@Component({
  selector: 'fdk-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FdkCheckboxComponent {
  @Input({ transform: booleanAttribute }) checked = false;
  @Input({ transform: booleanAttribute }) indeterminate = false;
  @Input() value: string = '';
  @Input({ transform: booleanAttribute }) disabled = false;

  readonly checkboxId = `fdk-checkbox-${nextCheckboxId++}`;
  readonly contentId = `${this.checkboxId}-content`;
}
